import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const AvatarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  border: ${({ image, hasBorder }) => (!image && hasBorder ? `1px solid ${COLORS.line}` : 'none')};
  border-radius: 50%;
  background-color: ${COLORS.black};
  background-image: ${({ image }) => (image ? `url(${image})` : 'none')};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

export default AvatarContainer;
